import { createMuiTheme } from '@material-ui/core/styles';
import i18next from 'i18next';

const theme = createMuiTheme({
  direction: i18next.dir(),
    palette: {
      primary:{
        main: "#FF9800",
        dark: "#F57C00",
        light: "#FFB74D"

      },
      secondary:{
        main: "#009688",
      },
    },
    typography: {
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        'Heebo',
        'Roboto',
        'Arial',
        'Helvetica',
        'sans-serif',
      ].join(',')
    }
  
  });


export default theme;


// WEBPACK FOOTER //
// ./src/helpers/Theme.js